import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VModal from 'vue-js-modal'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './css/gatewatch-styles.css'
import { OrganizationMap, OrganizationConfig, RoleNameMap } from './js/mappings'

Vue.config.productionTip = false

Vue.prototype.$organizationMap = OrganizationMap
Vue.prototype.$organizationConfig = OrganizationConfig
Vue.prototype.$roleNameMap= RoleNameMap

Vue.use(VModal)

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
